import React, { useState, useEffect } from 'react';
import { Row, Col, Card, Modal, Button, Badge, Spinner } from 'react-bootstrap';
import { Link, useNavigate } from 'react-router-dom';
import classNames from 'classnames';
import { VerticalForm, FormInput } from '../../../../components';
import Table from '../../../../components/Table';
import {
    addVendorAPI,
    editVendorAPI,
    deleteVendorAPI,
    getAllZonesAPI,
    getUserProfile,
    getAllVendorsPageAPI,
} from '../../../../API/RDPMS_API';
import moment from 'moment';
import * as yup from 'yup';
import { useTranslation } from 'react-i18next';
import { yupResolver } from '@hookform/resolvers/yup';
import { Loading } from 'react-loading-ui';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { AuthActionTypes } from '../../../../redux/auth/constants';
import { authApiResponseSuccess, updateUserAfterStationAdd } from '../../../../redux/actions';
import { useSelector, useDispatch } from 'react-redux';
import '../../../../../src/assets/scss/custom/components/_addstation.scss';
import 'bootstrap/dist/css/bootstrap.min.css';
import '@fortawesome/fontawesome-free/css/all.min.css';
import 'material-design-icons/iconfont/material-icons.css';
import { useForm } from 'react-hook-form';
import * as bootstrap from 'bootstrap';
import { addVendorColumns, addZoneColumns, sizePerPageList } from '../../../../utils/ColumnUtils';
import { APICore } from '../../../../helpers/api/apiCore';

const api = new APICore();
const AddVendors = () => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const [loader, setLoader] = useState(false);
    const [limit, setLimit] = useState(5);
    const [pageNumber, setPageNumber] = useState(1);
    const [pageCount, setPageCount] = useState(1);
    const [totalCount, setTotalCount] = useState(0);
    const [showModal, setShowModal] = useState(false);
    const [data, setData] = useState([]);

    const [showEditVendorModal, setShowEditVendorModal] = useState(false);
    const [editData, setEditData] = useState(null);
    const [showDeleteVendorModal, setShowDeleteVendorModal] = useState(false);
    const [zone, setZone] = useState([]);
    const [vendorToEdit, setVendorToEdit] = useState(null);
    const [vendorToDelete, setVendorToDelete] = useState(null);

    useEffect(() => {
        getAllVendorsData();
        getAllZoneData(limit, pageNumber);
    }, []);

    const { auth } = useSelector((state) => ({
        auth: state.Auth,
    }));

    let userId = auth && auth.user && auth.user._id && auth.user._id;
    const getAllZoneData = async () => {
        try {
            Loading();

            let response = await getAllZonesAPI();

            if (response && response?.length > 0) {
                setZone(response);
            }
        } catch (error) {
            console.error('Error zone data:', error);
            toast.error(t('Failed to refresh zone data'), {
                position: toast.POSITION.TOP_RIGHT,
            });
        } finally {
            Loading();
        }
    };
    const getAllVendorsData = async (limits, pages) => {
        try {
            Loading();

            let limitNumber = limits || limit;
            let pageNumberLocal = pages || pageNumber;

            let request = {
                limit: limitNumber,
                page: pageNumberLocal,
            };

            let response = await getAllVendorsPageAPI(request);
            console.log('VENDOR API RAW RESPONSE:', response);

            if (response && response.data && response.data.length > 0) {
                let vendorArray = response.data.map((item) => {
                    console.log('STATUS VALUE:', item.status);
                    return {
                        _id: item._id,
                        createdAt: moment(item.createdAt).format('Do MMM YYYY, h:mm A'),

                        vendor_cloud_code: item.vendor_cloud_code,
                        vendor_cloud_name: item.vendor_cloud_name,
                        vendor_gw_code: item.vendor_gw_code,
                        vendor_gw_name: item.vendor_gw_name,

                        status: item.status,

                        action: (
                            <div className="d-flex justify-content-center align-items-center gap-3">
                                <Link to="#" className="action-icon" onClick={() => openEditVendorModal(item)}>
                                    <i className="mdi mdi-pencil"></i>
                                </Link>

                                <Link
                                    to="#"
                                    className="action-icon text-danger"
                                    onClick={() => openDeleteVendorModal(item._id)}>
                                    <i className="mdi mdi-delete"></i>
                                </Link>
                            </div>
                        ),
                    };
                });

                // Correct pagination setters
                setPageNumber(response.currentPage || 1);
                setPageCount(response.totalPages || 1);
                setTotalCount(response.totalCount || response.data.length);

                setData(vendorArray);

                new bootstrap.Modal(document.getElementById('updateVendors')).show();
            } else {
                toast.error('No vendor data found', {
                    position: toast.POSITION.TOP_RIGHT,
                });
            }
        } catch (error) {
            console.error('Error fetching vendor data:', error);
            toast.error('Failed to refresh vendor data', {
                position: toast.POSITION.TOP_RIGHT,
            });
        } finally {
            Loading();
        }
    };

    const handlePageChange = async (value) => {
        setPageNumber(1);
        setLimit(value);
        await getAllVendorsData(value, 1);
    };

    const handlePageClick = async (value) => {
        setPageNumber(value);
        await getAllVendorsData(limit, value);
    };
    const closeModalWithHeaderClass = () => {
        setShowModal(false);
        reset();
    };
    const openModalWithHeaderClass = () => {
        setShowModal(true);
    };

    const vendorSchema = yup.object().shape({
        vendor_cloud_code: yup.string().required('Cloud Code is required'),
        vendor_cloud_name: yup.string().required('Cloud Name is required'),
        vendor_gw_code: yup.string().required('Gateway Code is required'),
        vendor_gw_name: yup.string().required('Gateway Name is required'),
        status: yup.string().required('Select Status'),
    });
    const {
        register: registerVendor,
        handleSubmit: handleSubmitAddVendor,
        formState: { errors: vendorErrors },
        reset,
    } = useForm({
        resolver: yupResolver(vendorSchema),
    });

    const {
        register: registerEditVendor,
        handleSubmit: handleSubmitEditVendor,
        formState: { errors: vendorEditErrors },
        reset: resetVendorEditForm,
        setValue: setEditVendorValue,
    } = useForm({
        resolver: yupResolver(vendorSchema),
    });

    const openEditVendorModal = (data) => {
        setEditData(data);
        setVendorToEdit(data);
        setShowEditVendorModal(true);
    };
    useEffect(() => {
        if (showEditVendorModal && editData) {
            setEditVendorValue('vendor_cloud_code', editData.vendor_cloud_code || '');
            setEditVendorValue('vendor_cloud_name', editData.vendor_cloud_name || '');
            setEditVendorValue('vendor_gw_code', editData.vendor_gw_code || '');
            setEditVendorValue('vendor_gw_name', editData.vendor_gw_name || '');
            setEditVendorValue('status', editData.status || '');
        }
    }, [showEditVendorModal, editData, setEditVendorValue]);

    const closeEditVendorModal = () => {
        setShowEditVendorModal(false);
        resetVendorEditForm();
    };

    // DELETE
    const openDeleteVendorModal = (id) => {
        setVendorToDelete(id);
        setShowDeleteVendorModal(true);
    };
    const closeDeleteVendorModal = () => {
        setVendorToDelete(null);
        setShowDeleteVendorModal(false);
    };

    const onAddVendor = async (formData) => {
        setLoader(true);
        try {
            Loading();

            const payload = { ...formData, created_by: userId };

            const response = await addVendorAPI(payload);

            if (response) {
                toast.success('Vendor Added Successfully');
                setShowModal(false);
                getAllVendorsData();
                reset();
            }
        } catch (err) {
            toast.error('Failed to Add Vendor');
        } finally {
            setLoader(false);
            Loading();
        }
    };

    const onUpdateVendor = async (formData) => {
        setLoader(true);

        try {
            formData._id = vendorToEdit?._id; // Selected vendor ID
            formData.created_by = userId;

            const response = await editVendorAPI(formData);

            if (response) {
                toast.success('Vendor updated successfully');
                getAllVendorsData(); // refresh list
                setShowEditVendorModal(false);
                resetVendorEditForm(); // clear form
            } else {
                toast.error('Failed to update vendor');
            }
        } catch (error) {
            console.error('Edit Vendor Error:', error);
            toast.error('Something went wrong');
        }

        setLoader(false);
    };

    const onDeleteVendor = async () => {
        try {
            Loading();

            const response = await deleteVendorAPI(vendorToDelete);

            if (response) {
                toast.success('Vendor Deleted Successfully');
                closeDeleteVendorModal();
                getAllVendorsData();
            }
        } catch (err) {
            toast.error('Failed to Delete Vendor');
        } finally {
            Loading();
        }
    };

    return (
        <div style={{ width: '100%' }}>
            {/* PAGE HEADER */}
            <div className="row">
                <div className="w-100 d-flex justify-content-between">
                    <div className="col-sm-6" style={{ marginLeft: '-2rem' }}>
                        <button className="btn_1">{t('VENDORS')}</button>
                    </div>

                    <div className="col-sm-6 d-flex justify-content-end">
                        <Button className="export text-black" onClick={openModalWithHeaderClass}>
                            <span className="d-flex align-items-center gap-1">
                                {t('ADD Vendors')} <i className="fas fa-plus"></i>
                            </span>
                        </Button>

                        {/* ONLY ZONE REFRESH */}
                        <button
                            className="update"
                            id="update"
                            type="button"
                            onClick={() => getAllVendorsData(limit, pageNumber)}>
                            {t('Update')} <i className="fas fa-sync-alt"></i>
                        </button>
                    </div>
                </div>
            </div>

            <Modal show={showModal} onHide={closeModalWithHeaderClass} centered>
                <Modal.Header closeButton style={{ backgroundColor: '#D9E9FF' }}>
                    <Modal.Title>{t('Add Vendor')}</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <form onSubmit={handleSubmitAddVendor(onAddVendor)}>
                        {/* Cloud Code */}
                        <div className="mb-3">
                            <label className="form-label">{t('Cloud Code')}</label>
                            <input
                                type="text"
                                className={`form-control ${vendorErrors.vendor_cloud_code ? 'is-invalid' : ''}`}
                                placeholder="Enter Cloud Code"
                                {...registerVendor('vendor_cloud_code')}
                            />
                            {vendorErrors.vendor_cloud_code && (
                                <p className="text-danger">{vendorErrors.vendor_cloud_code.message}</p>
                            )}
                        </div>

                        {/* Cloud Name */}
                        <div className="mb-3">
                            <label className="form-label">{t('Cloud Name')}</label>
                            <input
                                type="text"
                                className={`form-control ${vendorErrors.vendor_cloud_name ? 'is-invalid' : ''}`}
                                placeholder="Enter Cloud Name"
                                {...registerVendor('vendor_cloud_name')}
                            />
                            {vendorErrors.vendor_cloud_name && (
                                <p className="text-danger">{vendorErrors.vendor_cloud_name.message}</p>
                            )}
                        </div>

                        {/* Gateway Code */}
                        <div className="mb-3">
                            <label className="form-label">{t('Gateway Code')}</label>
                            <input
                                type="text"
                                className={`form-control ${vendorErrors.vendor_gw_code ? 'is-invalid' : ''}`}
                                placeholder="Enter Gateway Code"
                                {...registerVendor('vendor_gw_code')}
                            />
                            {vendorErrors.vendor_gw_code && (
                                <p className="text-danger">{vendorErrors.vendor_gw_code.message}</p>
                            )}
                        </div>

                        {/* Gateway Name */}
                        <div className="mb-3">
                            <label className="form-label">{t('Gateway Name')}</label>
                            <input
                                type="text"
                                className={`form-control ${vendorErrors.vendor_gw_name ? 'is-invalid' : ''}`}
                                placeholder="Enter Gateway Name"
                                {...registerVendor('vendor_gw_name')}
                            />
                            {vendorErrors.vendor_gw_name && (
                                <p className="text-danger">{vendorErrors.vendor_gw_name.message}</p>
                            )}
                        </div>

                        {/* Status */}
                        <div className="mb-3">
                            <label className="form-label">{t('Status')}</label>
                            <select
                                className={`form-select ${vendorErrors.status ? 'is-invalid' : ''}`}
                                {...registerVendor('status')}>
                                <option value="">{t('Select Status')}</option>
                                <option value="Active">Active</option>
                                <option value="Inactive">Inactive</option>
                            </select>
                            {vendorErrors.status && <p className="text-danger">{vendorErrors.status.message}</p>}
                        </div>

                        {/* Submit */}
                        <div className="d-flex justify-content-end">
                            <button
                                type="submit"
                                className="btn btn-submit"
                                style={{
                                    backgroundColor: '#F9B74C',
                                    width: '200px',
                                    borderRadius: '0%',
                                    border: 'none',
                                }}
                                disabled={loader}>
                                {loader ? (
                                    <>
                                        <Spinner as="span" animation="grow" size="sm" />
                                        Loading
                                    </>
                                ) : (
                                    <>
                                        <i className="mdi mdi-login"></i> {t('Submit')}
                                    </>
                                )}
                            </button>
                        </div>
                    </form>
                </Modal.Body>
            </Modal>

            <Modal show={showEditVendorModal} onHide={closeEditVendorModal} centered>
                <Modal.Header closeButton style={{ backgroundColor: '#D9E9FF' }}>
                    <Modal.Title>{t('Edit Vendor')}</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <form onSubmit={handleSubmitEditVendor(onUpdateVendor)}>
                        {/* Cloud Code */}
                        <div className="mb-3">
                            <label className="form-label">{t('Cloud Code')}</label>
                            <input
                                type="text"
                                className={`form-control ${vendorEditErrors.vendor_cloud_code ? 'is-invalid' : ''}`}
                                {...registerEditVendor('vendor_cloud_code')}
                            />
                            {vendorEditErrors.vendor_cloud_code && (
                                <p className="text-danger">{vendorEditErrors.vendor_cloud_code.message}</p>
                            )}
                        </div>

                        {/* Cloud Name */}
                        <div className="mb-3">
                            <label className="form-label">{t('Cloud Name')}</label>
                            <input
                                type="text"
                                className={`form-control ${vendorEditErrors.vendor_cloud_name ? 'is-invalid' : ''}`}
                                {...registerEditVendor('vendor_cloud_name')}
                            />
                            {vendorEditErrors.vendor_cloud_name && (
                                <p className="text-danger">{vendorEditErrors.vendor_cloud_name.message}</p>
                            )}
                        </div>

                        {/* Gateway Code */}
                        <div className="mb-3">
                            <label className="form-label">{t('Gateway Code')}</label>
                            <input
                                type="text"
                                className={`form-control ${vendorEditErrors.vendor_gw_code ? 'is-invalid' : ''}`}
                                {...registerEditVendor('vendor_gw_code')}
                            />
                            {vendorEditErrors.vendor_gw_code && (
                                <p className="text-danger">{vendorEditErrors.vendor_gw_code.message}</p>
                            )}
                        </div>

                        {/* Gateway Name */}
                        <div className="mb-3">
                            <label className="form-label">{t('Gateway Name')}</label>
                            <input
                                type="text"
                                className={`form-control ${vendorEditErrors.vendor_gw_name ? 'is-invalid' : ''}`}
                                {...registerEditVendor('vendor_gw_name')}
                            />
                            {vendorEditErrors.vendor_gw_name && (
                                <p className="text-danger">{vendorEditErrors.vendor_gw_name.message}</p>
                            )}
                        </div>

                        {/* Status */}
                        <div className="mb-3">
                            <label className="form-label">{t('Status')}</label>
                            <select
                                className={`form-select ${vendorEditErrors.status ? 'is-invalid' : ''}`}
                                {...registerEditVendor('status')}>
                                <option value="">{t('Select Status')}</option>
                                <option value="active">Active</option>
                                <option value="inactive">Inactive</option>
                            </select>
                            {vendorEditErrors.status && (
                                <p className="text-danger">{vendorEditErrors.status.message}</p>
                            )}
                        </div>

                        {/* Updated Date */}
                        <div className="mb-3">
                            <label className="form-label">{t('Updated Date')}</label>
                            <input
                                type="text"
                                className="form-control"
                                value={moment(vendorToEdit?.updatedAt).format('Do MMM YYYY, h:mm A')}
                                disabled
                            />
                        </div>

                        {/* Submit */}
                        <div className="d-flex justify-content-end">
                            <button
                                type="submit"
                                className="btn btn-submit"
                                style={{
                                    backgroundColor: '#F9B74C',
                                    width: '200px',
                                    borderRadius: '0%',
                                    border: 'none',
                                }}
                                disabled={loader}>
                                {loader ? (
                                    <>
                                        <Spinner as="span" animation="grow" size="sm" />
                                        Loading
                                    </>
                                ) : (
                                    <>
                                        <i className="mdi mdi-login"></i> {t('Submit')}
                                    </>
                                )}
                            </button>
                        </div>
                    </form>
                </Modal.Body>
            </Modal>

            <div className="modal fade" id="updateVendors" tabIndex="-1" aria-hidden="true">
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content">
                        <div className="modal-header close">
                            <button type="button" className="btn-close ms-auto" data-bs-dismiss="modal"></button>
                        </div>
                        <div className="modal-body text-center">
                            <img
                                src="/asset-images/checkmark.png"
                                alt="Success"
                                className="img-fluid"
                                style={{ maxWidth: '100px' }}
                            />
                            <p className="mt-3">{t('Vendors data refreshed successfully')}</p>
                        </div>
                    </div>
                </div>
            </div>

            <Modal show={showDeleteVendorModal} onHide={closeDeleteVendorModal} centered>
                <Modal.Header closeButton style={{ backgroundColor: '#D9E9FF' }}>
                    <Modal.Title>{t('Delete Vendor')}</Modal.Title>
                </Modal.Header>

                <Modal.Body className="text-center">
                    <img
                        src="/asset-images/deleteiconmodal.png"
                        alt="Delete"
                        className="img-fluid"
                        style={{ maxWidth: '100px' }}
                    />

                    <p className="mt-3">{t('Are you sure you want to delete this Vendor')}?</p>

                    <div className="d-flex justify-content-center gap-2">
                        <Button
                            variant="secondary"
                            onClick={closeDeleteVendorModal}
                            style={{ width: '100px', borderRadius: '0' }}>
                            No
                        </Button>

                        <Button
                            variant="outline-danger"
                            onClick={onDeleteVendor}
                            style={{
                                width: '100px',
                                borderRadius: '0',
                                border: '2px solid red',
                            }}>
                            Yes
                        </Button>
                    </div>
                </Modal.Body>
            </Modal>

            <div
                className="col-6 col-sm-6 card-add-station p-3 border-0 text-start no-radius my-2"
                style={{
                    width: '100%',
                    boxShadow: '0px 0px 35px rgba(154, 161, 171, 0.15)',
                }}>
                <div className="station-table-wrapper">
                    <Table
                        columns={addVendorColumns(t)}
                        data={data}
                        pageSize={limit}
                        pageCount={pageCount}
                        pageNumber={pageNumber}
                        totalCount={totalCount}
                        sizePerPageList={sizePerPageList}
                        isSortable={true}
                        pagination={true}
                        isSearchable={true}
                        onPageChange={handlePageChange}
                        onPageClick={handlePageClick}
                    />
                </div>
            </div>
        </div>
    );
};

export default AddVendors;
